import { selector } from '@poa/state';
import moment from 'moment';
import { extendMoment } from 'moment-range';

extendMoment(moment);

const colorEnum = {
  error: '#FFAEAC',
  warn: '#FFEFB2',
  complete: 'green'
};

export function calculateColor(data, currentTime) {
  if (data.amount >= data.plan) {
    return colorEnum.complete;
  } else {
    return colorEnum.error;
  }
}

export const daysToShow = selector(store => {
  const momentDates = store.dashboard.calendarData.tHeader.map(dateInteger => {
    const dateString = String(dateInteger);
    return moment(dateString, 'YYYYMMDD');
  });

  return momentDates.map(date => date.date());
});

export const monthToShow = selector(store => {
  const momentDates = store.dashboard.calendarData.tHeader.map(dateInteger => {
    const dateString = String(dateInteger);
    return moment(dateString, 'YYYYMM');
  });

  return momentDates.map(date => date.month() + 1);
});

export const weekDaysToShow = selector(store => {
  const momentDates = store.dashboard.calendarData.tHeader.map(dateInteger => {
    const dateString = String(dateInteger);
    return moment(dateString, 'YYYYMMDD');
  });
  return momentDates.map(date => date.format('ddd').toUpperCase());
});

export const monthNameToShow = selector(store => {
  const momentDates = store.dashboard.calendarData.tHeader.map(dateInteger => {
    const dateString = String(dateInteger);
    return moment(dateString, 'YYYYMM');
  });
  return momentDates.map(date => date.format('MMM').toUpperCase());
});

export const dashboardData = selector(store => {
  return store.dashboard.data
});

export const dashboardProfitData = selector(store => {
  return store.dashboard.profitData
});

export const usersData = selector(store => {
  const currentDate = moment();
  return store.dashboard.calendarData.data
    .map(itemData => {
      const data = itemData.days;
      const userId = itemData.index;
      const name = itemData.name;
      const nick = itemData.nick;
      const total = itemData.total;
      const totalPlan = itemData.total_plan;
      const teamLeads = itemData.team_leads;

      return {
        userId,
        name: name,
        nick: nick,
        userIndex: userId,
        total: total,
        totalPlan: totalPlan,
        teamLeads: teamLeads.map(item => ({
          ...item,
          days: Object.values(item.days)
        })),
        data: Object.keys(data).map(date => (
          { ...data[date], date, color: calculateColor(data[date], currentDate) })
        )
      };
    });
});